import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {LabelsService} from "../../../labels/services/labels-service.service";

export class vehiclePanelCtrl implements IController {

  vehicle: any;
  agents: any;
  loading: boolean;
  onEditInfo: Function;
  onEditCapacity: Function;
  onClose: Function;
  onAddDriver: Function;
  onDelete: Function;

  private siteLabelsMap: any;
  private weightConfig: any;
  private dimensionsConfig: any;
  private distanceConfig: any;

  /* @ngInject */
  constructor(private splitService, private $log, private labelsService: LabelsService) {}

  $onInit() {
    this.siteLabelsMap = undefined;
    this.weightConfig = this.splitService.getWeightUnit();
    this.dimensionsConfig = this.splitService.getVolumeUnit();
    this.distanceConfig = this.splitService.getSiteDistanceLargeUnit(true);

    this.labelsService.getAll()
      .then((labels: any) => {
        this.siteLabelsMap = {};
        _.forEach(labels, (l) => {
          this.siteLabelsMap[l.name] = l;
        })
      })
      .catch((error) => {
        this.$log.error('Failed to get labels @vehiclePanelCtrl@onInit', error);
      })

  };

  $onChanges(changes) {
    if (changes.vehicle && changes.vehicle.currentValue) {
      this.$onInit();
    }
  }

}
angular
  .module('bringoz.admin.vehicles')
  .component('vehiclePanel', {
    bindings: {
      vehicle: '<',
      agents: '<',
      loading: '<?',
      onEditInfo: '&',
      onEditCapacity: '&',
      onClose: '&',
      onAddDriver: '&',
      onDelete: '&'
    },
    template: require('./vehicle-panel.html').default,
    controller: vehiclePanelCtrl
  });
